<template>

    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
    </teleport>

    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <h3 class="text-3xl py-10">{{ labelGender }} <span class="font-bold">{{ me.name }}</span></h3>
            <div class="grid grid-cols-6 gap-3 mb-5">
                <a href="https://nextyu-qaprod.nextgroup.eu/" target="_blank" class="bg-white p-4 h-20">
                    <div class="flex-shrink font-bold">CRM</div>
                </a>
                <component
                    v-bind:is="'router-link'"
                    :to="{name:'ListaProgetti'}" class="bg-white p-4 h-20">
                    <div class="flex-shrink font-bold">PROGETTI</div>
                </component>
                <div class="bg-next-gray-md-darker p-4 h-20"></div>
                <div class="bg-next-gray-md-darker p-4 h-20"></div>
                <div class="bg-next-gray-md-darker p-4 h-20"></div>
                <div class="bg-next-gray-md-darker p-4 h-20"></div>
            </div>
            <div class="grid grid-cols-4 gap-3 items-start">
                <div>
                    <p class="font-bold mb-3">ALERT</p>
                    <div class="grid-cols-1 grid gap-3">
                        <AlertCard
                            :vediLink="{name:'AlertScaduti'}"
                            class="h-36"
                            titolo="Alert scaduti"
                            :numero="meCounters?.scaduti"
                            colore-stato-class="text-next-orange text-xl leading-none"></AlertCard>
                        <AlertCard
                            :vediLink="{name:'AlertScadenza'}"
                            class="h-36"
                            titolo="Alert in scadenza"
                            :numero="meCounters?.in_scadenza"
                            colore-stato-class="text-next-pre text-xl leading-none"></AlertCard>
                        <AlertCard
                            :vediLink="{name:'RichiamaEntro'}"
                            class="h-36"
                            titolo="Stato ok"
                            :numero="meCounters?.ok"
                            colore-stato-class="text-next-atp text-xl leading-none"></AlertCard>
                    </div>
                </div>

                <div>
                    <p class="font-bold mb-3">PROGETTI</p>
                    <div class="grid-cols-1 grid gap-3">
                        <div v-for="p in [0,1,2]">
                            <div v-if="progetti[p]" class="bg-white flex flex-col justify-between p-3 h-36">
                                <div class="flex-shrink font-bold text-sm">{{ progetti[p].titolo }}</div>
                                <div class="xs:flex justify-between items-end text-center xs:text-left">
                                    <div class="font-bold text-xl leading-none">{{ progetti[p].denominazione }}</div>
                                    <div class="mt-2 xs:mt-0">
                                        <router-link :to="{name:'DettaglioProgetto', params:{id:progetti[p].id}}"
                                                     class="border border-1 border-next-neu px-3 py-1 text-xs">Vedi
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="bg-next-gray-md-darker h-36">
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <p class="font-bold mb-3">CONTATTI</p>
                    <div class="grid-cols-1 grid gap-3">
                        <div v-for="c in [0,1,2]">
                            <ContattoCard v-if="contatti[c]" :key="contatti[c].id" :id="contatti[c].azienda_id"
                                          :cid="contatti[c].id"
                                          :cliente="contatti[c].nome"
                                          :sottotitolo="contatti[c].posizione_lavorativa" class="h-36">

                            </ContattoCard>
                            <div v-else class="bg-next-gray-md-darker h-36">
                            </div>
                        </div>

                    </div>
                </div>

                <div>
                    <p class="font-bold mb-3">ALERT</p>
                    <div class="grid-cols-1 grid gap-3">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {mapActions, mapGetters} from 'vuex';
import AlertCard from "@/components/AlertCard.vue";
import meManager from "../api/Me";
import Loading from "@/components/Loading.vue";
import progettiManager from "../api/Progetti";
import ContattoCard from "@/components/ContattoCard.vue";
import contattiManager from "../api/Contatti";
import Topbar from "@/components/Topbar.vue";
import env from "../Environment";

@Options({
    name:'Home',
    components: {
        Topbar,
        AlertCard,
        ContattoCard,
        Loading
    },
    computed: {
        ...mapGetters([
            'me',
            'labelGender',
            'meCounters'
        ])
    },
    methods:{
        ...mapActions([
            'fetchCounters'
        ])
    }
})
export default class Home extends Vue {
    env = env
    $store: any;
    loading = false
    meCounters!:any
    fetchCounters!:any

    progetti: any = []
    contatti: any = []

    created(): void {
        this.loading = true
        Promise.all([
            progettiManager.myProgetti().then((response) => {
                const {data, ...pag} = response.data;
                this.progetti = data
            }),
            contattiManager.myContatti().then((response) => {
                const {data, ...pag} = response.data;
                this.contatti = data
            }),
            this.fetchCounters()
        ]).finally(() => {
            this.loading = false
        })
    }

    toggle() {
        this.$store.commit('toggle_menu')
    }
}

</script>


<style lang="scss">

</style>
